import { Row } from "antd";
import React from "react";
import packageJson from '../../../../package.json';

const FooterComponent = () => {
  return (
      <Row align="bottom" justify="center">
        <div className="footer">Version {packageJson.version} | © TaskUs @ {new Date().getFullYear().toString()} | <a rel="noreferrer" href="https://hackerone.com/2bb0b37b-4b88-4fd5-922e-7373bd55e822/embedded_submissions/new" target="_blank">Security</a>  </div>
      </Row>
  );
};

export default FooterComponent;
